import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * GSAP ScrollTriggerアニメーション初期化
 */
export function initScrollAnimations() {
  // 既存のScrollTriggerをクリア
  ScrollTrigger.getAll().forEach(trigger => trigger.kill());

  // ページロード時のフェードインアニメーション
  const fadeInElements = document.querySelectorAll('.js-fade-in');
  fadeInElements.forEach(element => {
    gsap.to(element, {
      opacity: 1,
      y: 0,
      duration: 1.2,
      ease: 'power2.out',
      delay: 0.3,
    });
  });

  // u-inset - 左から右へマスクを外すアニメーション
  const insetElements = document.querySelectorAll('.u-inset');
  insetElements.forEach(element => {
    gsap.fromTo(
      element,
      {
        clipPath: 'inset(0 100% 0 0)', // 左から完全にマスク
      },
      {
        clipPath: 'inset(0 0% 0 0)', // マスク解除
        duration: 1.5,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: element,
          start: 'top 80%', // 要素の上端がビューポートの80%の位置に来たら開始
          end: 'top 50%',
          toggleActions: 'play none none none',
          // markers: true, // デバッグ用(本番では削除)
        },
      }
    );
  });

  if (insetElements.length > 0) {
    console.log(`🎬 ${insetElements.length} inset animations initialized`);
  }
}
